export enum userRole {
  admin = 1,
  doctor = 2,
  pharmacist = 3,
  pharmacistSubAdmin = 4,
}
